import React, { useMemo } from "react";
import { AreaChart, Area, Line, ReferenceLine, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from "recharts";
import { Panel, COLORS, formatILS, ChartTooltipStyle } from "./ui";

const LABELS = { total: "הכנסה כוללת", private: "פרטי", group: "קבוצתי", refunds: "החזרים" };

const RevenueChart = ({ data, loading, error, onRetry }) => {
  const avg = useMemo(() => {
    if (!data || data.length === 0) return 0;
    return Math.round(data.reduce((s, d) => s + d.total, 0) / data.length);
  }, [data]);

  return (
    <Panel
      eyebrow="הכנסות"
      title="גרף הכנסות"
      subtitle="הכנסה כוללת מול פרטי / קבוצתי / החזרים"
      accent="indigo"
      loading={loading}
      error={error}
      onRetry={onRetry}
      empty={!loading && !error && (!data || data.length === 0)}
    >
      <div className="h-56 sm:h-64">
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart data={data} margin={{ top: 5, right: 5, left: -10, bottom: 0 }}>
            <defs>
              <linearGradient id="revTotal" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor={COLORS.indigo} stopOpacity={0.35} />
                <stop offset="100%" stopColor={COLORS.indigo} stopOpacity={0} />
              </linearGradient>
            </defs>
            <CartesianGrid stroke={COLORS.grid} vertical={false} />
            <XAxis dataKey="period" tick={{ fontSize: 12, fill: "#6b7280" }} axisLine={false} tickLine={false} />
            <YAxis tick={{ fontSize: 12, fill: "#6b7280" }} axisLine={false} tickLine={false} />
            <Tooltip formatter={(val, name) => [formatILS(val), LABELS[name] || name]} contentStyle={ChartTooltipStyle} />
            <Legend wrapperStyle={{ fontSize: 11 }} formatter={(v) => LABELS[v] || v} />
            <Area type="monotone" dataKey="total" stroke={COLORS.indigo} strokeWidth={2.5} fill="url(#revTotal)" />
            <Line type="monotone" dataKey="private" stroke={COLORS.sky} strokeWidth={1.75} dot={false} />
            <Line type="monotone" dataKey="group" stroke={COLORS.purple} strokeWidth={1.75} dot={false} />
            <Line type="monotone" dataKey="refunds" stroke={COLORS.rose} strokeWidth={1.75} strokeDasharray="3 3" dot={false} />
            <ReferenceLine y={avg} stroke={COLORS.slate} strokeDasharray="4 4" label={{ value: `ממוצע ${formatILS(avg)}`, fontSize: 10, fill: "#64748b", position: "insideTopLeft" }} />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </Panel>
  );
};

export default RevenueChart;
